/* global site: false, __: false, app: true, win: true, urlParams: false, pad: false */
$(document).ready(function(){
	var contentCarousels = [],
		imageCarousels = [],
		blockCarousels = [],
		defaultCarousels = [];

	if(win.innerWidth() > app.mediaBreaks.tablet){
		$('.menu-carousel').owlCarousel({
			autoWidth: true,
			dots: false,
			margin: 24,
			nav: true,
			navText: ['&#xf053;', '&#xf054;']
		});
	}

	$('.content-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.phone) return;
		var loop = $(this).hasClass('loop');
		var that = $(this),
			rightAlign = that.hasClass('right-align-carousel'),
			carousel = that.owlCarousel({
				autoWidth: true,
				dots: false,
				margin: win.innerWidth() <= app.mediaBreaks.tablet ? 15 : rightAlign || that.hasClass('small-margin') ? 45 : that.hasClass('no-margin') ? 0 : 175,
				nav: false,
				rtl: rightAlign,
				loop: loop
			});

		carousel.carouselIndex = 1;

		contentCarousels.push(carousel);

		that.closest('section').find('.index-carousel-controls .index-control').click(function(){
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
			carousel.trigger('to.owl.carousel', [$(this).index()]);
		});

		that.next().find('.page-control-prev').click(function(){
			if(loop) carousel.carouselIndex -= 1;
			carousel.trigger('prev.owl.carousel');
		});

		that.next().find('.page-control-next').click(function(){
			if(loop) carousel.carouselIndex += 1;
			carousel.trigger('next.owl.carousel');
		});

		carousel.on('changed.owl.carousel', function(e){
			if(loop){
				carousel.carouselIndex = carousel.carouselIndex > e.item.count ? 1 : carousel.carouselIndex < 1 ? e.item.count : carousel.carouselIndex;

				that.next().find('.page-count-current').text(carousel.carouselIndex);
			}else{
				that.next().find('.page-count-current').text(e.item.index + 1);
			}
		});
	});

	$('.image-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.phone) return;

		var that = $(this),
			carousel = that.owlCarousel({
				autoWidth: true,
				center: win.innerWidth() > app.mediaBreaks.tablet,
				dots: false,
				loop: true,
				nav: false,
				onRefreshed: function(){
					that.find('img.modal-img').off('click');
					that.find('img.modal-img').click(function(e){
						var caption = $(this).nextAll('meta[name="caption"]') ? $(this).nextAll('meta[name="caption"]').attr('content') : null;
						var title = $(this).nextAll('meta[name="title"]') ? $(this).nextAll('meta[name="title"]').attr('content') : null;

						e.preventDefault();
						app.modalImg(this, caption, title);
					});
				}
			});

		carousel.carouselIndex = 1;

		imageCarousels.push(carousel);

		that.next().find('.page-control-prev').click(function(){
			carousel.carouselIndex -= 1;
			carousel.trigger('prev.owl.carousel');
		});

		that.next().find('.page-control-next').click(function(){
			carousel.carouselIndex += 1;
			carousel.trigger('next.owl.carousel');
		});

		carousel.on('changed.owl.carousel', function(e){
			carousel.carouselIndex = carousel.carouselIndex > e.item.count ? 1 : carousel.carouselIndex < 1 ? e.item.count : carousel.carouselIndex;
			that.next().find('.page-count-current').text(carousel.carouselIndex);
		});
	});

	$('.block-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.phone) return;

		var that = $(this),
			carousel = that.owlCarousel({
				autoWidth: true,
				dots: false,
				loop: false,
				margin: 16,
				nav: false
			});

		blockCarousels.push(carousel);

		that.next().find('.page-control-prev').click(function(){
			carousel.trigger('prev.owl.carousel');
		});

		that.next().find('.page-control-next').click(function(){
			carousel.trigger('next.owl.carousel');
		});
	});

	$('.default-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.phone) return;

		var that = $(this),
			carousel = that.owlCarousel({
				autoWidth: false,
				center: true,
				dots: false,
				items: 1,
				loop: false,
				margin: 0,
				nav: false
			});

		defaultCarousels.push(carousel);

		that.closest('.container').find('.page-control-prev').click(function(){
			carousel.trigger('prev.owl.carousel');
		});

		that.closest('.container').find('.page-control-next').click(function(){
			carousel.trigger('next.owl.carousel');
		});

		carousel.on('changed.owl.carousel', function(e){
			that.closest('.container').find('.page-count-current').text(e.item.index + 1);
		});
	});
});
